import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Modal from '@components/Modal/Modal';
import { inquiryDetailsSelector } from '@store/features/inquiryDraft/inquiryDetails/selectors';

import { ISubmitInquirySuccessModalProps } from './SubmitInquirySuccessModal.interface';

import './style.scss';

const SubmitInquirySuccessModal: FC<ISubmitInquirySuccessModalProps> = ({
  open,
  onClose,
  onExited,
  title = '',
}) => {
  const { t } = useTranslation();

  const inquiryDetails = useSelector(inquiryDetailsSelector);

  return (
    <Modal
      onClose={onClose}
      onExited={onExited}
      open={open}
      icon={
        <img
          className="submit-inquiry-success-modal__icon"
          src="/images/img-paperairplane.svg"
          alt="Success"
        />
      }
      title={title}
      className="submit-inquiry-success-modal"
      rightActionTitle={t('submitInquiry.confirmationClose')}
      onRightAction={onClose}
    >
      <p className="submit-inquiry-success-modal__inquiry-number">{inquiryDetails?.name}</p>
    </Modal>
  );
};

export default SubmitInquirySuccessModal;
